export const _yesOrNoList = [
    {id: "no", value: "No"},
    {id: "yes", value: "Yes"}
];

export const documentTypeList = [
    {id: "", value: "Please Select"},
    {id: "passport", value: "Passport"},
    {id: "bankStatement", value: "Bank Statement"},
    {id: "visa", value: "Visa"},
    {id: "utilityBill", value: "Utility Bill"},
    {id: "drivingLicense", value: "Driving License"},
    {id: "siaLicense", value: "SIA License"},
    {id: "others", value: "Others"},
];

export const employmentTypeList = [
    {id: "employment", value: "Previous Employment"},
    {id: "education", value: "Previous Education"},
    {id: "selfEmploymentTrade", value: "Self Employment / Trade"},
    {id: "unemployed", value: "Unemployed"},
    {id: "others", value: "Others"},
];

export const organizationList = [
    {id: "", value: "Select Organization"},
    {id: "abc", value: "ABC"},
    {id: "xyz", value: "XYZ"}
];

export const positionList = [
    {id: "", value: "Select Position"},
    {id: "abc", value: "ABC"},
    {id: "xyz", value: "XYZ"}
];

export const agencyList = [
    {id: "", value: "Select Agency"},
    {id: "abc", value: "ABC"},
    {id: "xyz", value: "XYZ"}
];
export const screeningTypeList = [
    {id: "internalScreening", value: "Internal Screening"},
    {id: "externalScreening", value: "External Screening"},
];
export const screeningCreditsByType = {
    internal: 10,
    admin: 15
};
export const genderList = [
    {id: "", value: "Select Gender"},
    {id: "Male", value: "Male"},
    {id: "Female", value: "Female"}
];
export const titleList = [
    {id: "", value: "Select Title"},
    {id: "Mr", value: "Mr"},
    {id: "Miss", value: "Miss"},
    {id: "Mrs", value: "Mrs"}
];

export const siaLicenseTypeList = [
    { id: "", value: "Please Select", disabled: false },
    { id: "DSS", value: "DSS", disabled: false },
    { id: "Security Guarding", value: "Security Guarding", disabled: false },
    { id: "CCTV", value: "CCTV", disabled: false },
    { id: "Close Protection", value: "Close Protection", disabled: false },
    { id: "Key Holding", value: "Key Holding", disabled: false },
    { id: "drivingLicense", value: "Driving License", disabled: false },
    { id: "nonFrontLine", value: "Non Front Line", disabled: false },
    { id: "others", value: "Others", disabled: false },
];
export const visaTypeList = [
    {id: "", value: "Please Select"},
    {id: "Spouse", value: "Spouse"},
    {id: "Student", value: "Student"},
    {id: "Limited Leave To Remain", value: "Limited Leave To Remain"},
    {id: "others", value: "Others"},
];
export const employmentDetailsTypeList = [
    {id: "p45", value: "p45"},
    {id: "p46", value: "p46"}
];
export const p46List = [
    {id: "p46A", value: "p46 A"},
    {id: "p46B", value: "p46 B"},
    {id: "p46C", value: "p46 C"},
];
export const drivingLicenseTypeList = [
    {id: "", value: "Please Select"},
    {id: "fullDrivingLicense", value: "Full Driving License"},
    {id: "provisionalDrivingLicense", value: "Provisional Driving License"},
];
export const relationShipTypeList = [
    {id: "", value: "Please Select"},
    {id: "Friend", value: "Friend"},
    {id: "Relative", value: "Relative"},
    // {id: "Coludge", value: "Celative"},
    {id: "others", value: "Others"},
];


export const countryList = [
    {id: "", value: "Select Nationality"},
    {id: "Afghan", value: "Afghan"},
    {id: "Albanian", value: "Albanian"},
    {id: "Algerian", value: "Algerian"},
    {id: "American", value: "American"},
    {id: "Argentine", value: "Argentine"},
    {id: "Australian", value: "Australian"},
    {id: "Austrian", value: "Austrian"},
    {id: "Bangladeshi", value: "Bangladeshi"},
    {id: "Belgian", value: "Belgian"},
    {id: "Bolivian", value: "Bolivian"},
    {id: "Brazilian", value: "Brazilian"},
    {id: "British", value: "British"},
    {id: "Bulgarian", value: "Bulgarian"},
    {id: "Cambodian", value: "Cambodian"},
    {id: "Canadian", value: "Canadian"},
    {id: "Chilean", value: "Chilean"},
    {id: "Chinese", value: "Chinese"},
    {id: "Colombian", value: "Colombian"},
    {id: "Croatian", value: "Croatian"},
    {id: "Cuban", value: "Cuban"},
    {id: "Czech", value: "Czech"},
    {id: "Danish", value: "Danish"},
    {id: "Dutch", value: "Dutch"},
    {id: "Egyptian", value: "Egyptian"},
    {id: "Filipino", value: "Filipino"},
    {id: "Finnish", value: "Finnish"},
    {id: "French", value: "French"},
    {id: "German", value: "German"},
    {id: "Greek", value: "Greek"},
    {id: "Guatemalan", value: "Guatemalan"},
    {id: "Indian", value: "Indian"},
    {id: "Indonesian", value: "Indonesian"},
    {id: "Iranian", value: "Iranian"},
    {id: "Iraqi", value: "Iraqi"},
    {id: "Irish", value: "Irish"},
    {id: "Israeli", value: "Israeli"},
    {id: "Italian", value: "Italian"},
    {id: "Japanese", value: "Japanese"},
    {id: "Kenyan", value: "Kenyan"},
    {id: "Korean", value: "Korean"},
    {id: "Kuwaiti", value: "Kuwaiti"},
    {id: "Lebanese", value: "Lebanese"},
    {id: "Malaysian", value: "Malaysian"},
    {id: "Mexican", value: "Mexican"},
    {id: "Moroccan", value: "Moroccan"},
    {id: "Nepalese", value: "Nepalese"},
    {id: "Nigerian", value: "Nigerian"},
    {id: "Norwegian", value: "Norwegian"},
    {id: "Pakistani", value: "Pakistani"},
    {id: "Peruvian", value: "Peruvian"},
    {id: "Polish", value: "Polish"},
    {id: "Portuguese", value: "Portuguese"},
    {id: "Romanian", value: "Romanian"},
    {id: "Russian", value: "Russian"},
    {id: "Saudi Arabian", value: "Saudi Arabian"},
    {id: "South African", value: "South African"},
    {id: "Spanish", value: "Spanish"},
    {id: "Sri Lankan", value: "Sri Lankan"},
    {id: "Swedish", value: "Swedish"},
    {id: "Swiss", value: "Swiss"},
    {id: "Syrian", value: "Syrian"},
    {id: "Thai", value: "Thai"},
    {id: "Turkish", value: "Turkish"},
    {id: "Ukrainian", value: "Ukrainian"},
    {id: "Venezuelan", value: "Venezuelan"},
    {id: "Vietnamese", value: "Vietnamese"},
    {id: "Yemeni", value: "Yemeni"},
    {id: "Zimbabwean", value: "Zimbabwean"}
];
